import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { customer: { customer } } = apiUrls

export const CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS';
export const CUSTOMER_LOADING = 'CUSTOMER_LOADING';
export const TABLE_LOADING = 'TABLE_LOADING';

export const getCustomersData = ({ amazonOrderId, name,
    address, page, pageSize, vendor }) => async (dispatch) => {

        try {
            if (vendor) {
                const requestData = {
                    ...customer,
                    data: {
                        amazonOrderId,
                        name,
                        address,
                        page,
                        pageSize
                    }
                };
                const data = await REQUEST(requestData);
                dispatch({
                    type: CUSTOMER_SUCCESS,
                    data,
                    vendor
                })
            }

        } catch (e) {

            dispatch({
                type: CUSTOMER_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                },
                vendor
            })
        }
    }

export const handleLoader = (isLoading, vendor) => (dispatch) => {
    if (vendor) {
        dispatch({
            type: CUSTOMER_LOADING,
            isLoading,
            vendor
        });
    }
}


export const handleTableLoader = (isTableLoading, vendor) => (dispatch) => {
    if (vendor) {
        dispatch({
            type: TABLE_LOADING,
            isTableLoading,
            vendor
        });
    }
}